import { useMemo } from 'react';

import { useUserSelector } from '@core/js/store/hooks';

import { getContactPreferencesForFront } from '@interlayer/js/app/components/main/MarketingPreferences/helpers';

export const useInitialMarketingValues = () => {
    const contactPreferences = useUserSelector((state) => state.userDetails.contactPreferences);

    return useMemo(() => getContactPreferencesForFront(contactPreferences), [contactPreferences]);
};
